<script setup lang="ts">
import type { SiteBlockData, SiteBlockSettings } from '../../../types/site'

defineProps<{ data: SiteBlockData, settings: SiteBlockSettings }>()

// Manual accordion toggle — one open item at a time, no external dependency.
const open = ref<number | null>(null)
const toggle = (i: number) => {
  open.value = open.value === i ? null : i
}
</script>

<template>
  <div>
    <SiteSectionHeading
      :eyebrow="data.eyebrow"
      :title="data.headline"
      class="mb-6"
    />
    <div
      v-if="data.faqs?.length"
      class="mx-auto max-w-2xl divide-y divide-[var(--site-border)]"
    >
      <div
        v-for="(faq, i) in data.faqs"
        :key="i"
      >
        <button
          type="button"
          class="flex w-full items-center justify-between gap-4 py-4 text-left"
          :aria-expanded="open === i"
          @click="toggle(i)"
        >
          <span class="font-semibold">{{ faq.question }}</span>
          <svg
            class="size-4 shrink-0 text-[var(--site-muted)] transition-transform"
            :class="open === i ? 'rotate-180' : ''"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            aria-hidden="true"
          >
            <path
              d="m6 9 6 6 6-6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div
          v-if="open === i"
          class="whitespace-pre-line pb-4 text-[var(--site-muted)]"
        >
          {{ faq.answer }}
        </div>
      </div>
    </div>
  </div>
</template>
